import { mapValues } from '@exodus/basic-utils';
import { url } from '@exodus/fetch/url';
import { DEFAULT_URL } from './constants.js';
import { memoizeWithTimeout } from '../../utils.js';
class PricingService {
    _baseUrl;
    _fetchival;
    constructor({ baseUrl = DEFAULT_URL, fetchival }) {
        this._baseUrl = new URL(baseUrl);
        this._fetchival = fetchival;
    }
    getPrices = memoizeWithTimeout(async (ids) => {
        const prices = await this._fetchival(url `${this._baseUrl}/current-price`, {
            headers: { 'Content-Type': 'application/json', 'Cache-Control': 'max-age=60' },
        }).get({
            from: ids,
            to: 'USD',
        });
        return mapValues(prices, (price) => price.USD);
    }, (ids) => ids.join('-'), 60_000);
}
export default PricingService;
